var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorCircleBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60ZM34.128 17.496C34.128 17.64 34.08 17.784 34.08 17.928L31.392 35.352H28.608L25.92 17.928C25.92 17.784 25.872 17.64 25.872 17.496C25.872 15.336 28.032 14.04 30 14.04C31.968 14.04 34.128 15.336 34.128 17.496ZM33.792 41.64C33.792 43.752 32.112 45.432 30 45.432C27.888 45.432 26.208 43.752 26.208 41.64C26.208 39.528 27.888 37.848 30 37.848C32.112 37.848 33.792 39.528 33.792 41.64Z",
    fill: "#1976D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorCircleBlue);
export default __webpack_public_path__ + "static/media/error-circle-blue.374c67867c1892d70b9df703fe05d42e.svg";
export { ForwardRef as ReactComponent };